import http from "../../services/httpService";
import { injectHtml } from "../../utils/htmlUtil";
import { openDialog, dialogModel } from "../common/dialog";
import forms from "../common/forms";
import { error, isEmpty, initToggleIconRotate, rotateElement } from "../common/global";
import { catchError } from "../../utils/errorUtil";

const props = {

    orderPlacedSuccessMarker: '#marker-order-success',
    convertGuestAccountWrapper: '#convert-guest-account-wrapper',
    addToBasketListItem: '.add-to-basket-list-item',
    selectProductOptionMessage: '#select-product-option-message',

};

export function initPaymentSuccess() {

    if ($(props.convertGuestAccountWrapper).length) {
        initConvertGuestAccountEvents();
    }

    if ($(props.orderPlacedSuccessMarker).length) {

        //upon order success call a site URL that will call a service that will generate the required order workflow emails (and pdf's).
        processOrderEmailTasksService();

        buildGaFourDatalayerModel();
    }
}

function initConvertGuestAccountEvents() {

    catchError(async function () {

        const formObject = $('#convert-guest-account-form');
        const save_button = $('#submit-convert-convert-account');

        //initialise jquery validation for the injected form
        const validator = forms.onloadValidationSetupByObject(formObject);

        $(save_button).off('click').on('click', async function () {
            saveConvertGuestAccountForm(formObject, validator);
        });
    });
}

async function saveConvertGuestAccountForm(formObject, validator) {

    //validate form
    if (formObject.valid()) {

        const buttonTextWrapper = $('.submit-button-text-wrapper');
        const activityIndicators = $('.submit-button-activity');

        buttonTextWrapper.hide();
        activityIndicators.show().css("display", "inline-block");

        //NOTE: passing true to the second element will briefly enable all disabled form elements prior to form serialization and submission.
        forms.formUnderSubmission(true, true);

        setTimeout(async function () {

            const formValues = formObject.serialize();

            //attempt POST save, the check response
            const response = await convertGuestAccountService(formValues);

            if (response.responseType === "SUCCESS") {

                //hide form, display confirmation panel
                $('#convert-account-form-wrapper').hide(500, function () {

                    $('#account-converted-confirmation-wrapper').show(500);
                });
            }
            else {
                //display failure notification in some way
                var failureMessage = response.responseMessage;

                //display failure snackbar
                openSnackbar({
                    ...snackbarModel,
                    content: failureMessage,
                    remain: true
                });
            }

            forms.formUnderSubmission(false, true);

            buttonTextWrapper.show();
            activityIndicators.show().css("display", "none");

        }, 1000);
    } else {

        forms.scrollToFirstError(validator, $(document).height() * 0.5);
    }

}

//LEGACY FUNCTION. Retained until GA4 implementation is in place.
async function buildGtmDatalayerModel() {

    const data = {
        orderId: $(props.orderPlacedSuccessMarker).data('oid')
    };

    const response = await getGtmDataModel(data);

    if (response.responseType === "SUCCESS") {

        //need to build the GTM datalayer object and push to GTM
        var gtmOrderItems = [];

        for (var i = 0; i < response.orderItems.length; i++) {

            var orderItem = response.orderItems[i];

            if (!orderItem.isDiscount) {

                gtmOrderItems.push({
                    'sku': orderItem.sku,
                    'name': orderItem.title,
                    'category': orderItem.category,
                    'price': orderItem.unitPriceExclVat,
                    'quantity': orderItem.quantity
                });
            }
            else {

                gtmOrderItems.push({

                    //'sku' changes to 'coupon' for the voucher item
                    'coupon': orderItem.sku,
                    'name': orderItem.title,
                    'category': orderItem.category,
                    'price': orderItem.unitPriceExclVat,
                    'quantity': orderItem.quantity
                });
            }
        }

        window.dataLayer = window.dataLayer || [];

        dataLayer.push({
        'transactionId': response.orderId,
            'transactionAffiliation': response.affiliation,
            'transactionTotal': response.orderTotal,
            'transactionTax': response.vat,
            'transactionShipping': response.delivery,
            'transactionProducts': gtmOrderItems
        });
    }
    else {

        //should we do anything if this fails?
    }

}

async function buildGaFourDatalayerModel() {

    const data = {
        orderId: $(props.orderPlacedSuccessMarker).data('oid')
    };

    const response = await getGaFourDataModel(data);

    if (response.responseType === "SUCCESS") {

        //need to build the GTM datalayer object and push to GTM - this is for GA4 e commerce tracking
        var gtmOrderItems = [];

        for (var i = 0; i < response.orderItems.length; i++) {

            var orderItem = response.orderItems[i];

            gtmOrderItems.push({
                item_id: orderItem.sku,
                item_name: orderItem.title,
                affiliation: orderItem.affiliation,
                coupon: orderItem.coupon,
                discount: orderItem.discount,
                index: i,
                item_brand: orderItem.itemBrand,
                item_category: orderItem.itemCategory,
                item_category2: orderItem.itemCategory2,
                item_category3: orderItem.itemCategory3,
                item_category4: orderItem.itemCategory4,
                item_category5: orderItem.itemCategory5,

                price: orderItem.unitPriceInclVat,
                quantity: orderItem.quantity
            });
        }

        window.dataLayer = window.dataLayer || [];

        var order = {
            event: 'purchase',
            ecommerce: {
                transaction_id: response.orderId,
                value: response.orderTotal,
                tax: response.vat,
                shipping: response.delivery,
                currency: response.currency,
                coupon: response.coupon,
                items: gtmOrderItems
            }
        };

        dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
        dataLayer.push(order);
    }
    else {

        //should we do anything if this fails?
    }

}

async function convertGuestAccountService(data) {

    //no TRY CATCH as handled by parent
    //calls a service to convert the guest account to a retail account
    const response = await http.post('/account/convertguestaccount', data);

    return response.data;
}

async function processOrderEmailTasksService() {

    //no TRY CATCH as handled by parent
    const response = await http.get('/processorderemailtasksasync');

    return response.data;
}

async function getGaFourDataModel(data) {

    //no TRY CATCH as handled by parent
    const response = await http.get('/seo/ordergafourmodel', data);

    return response.data;
}